import { SITE, WA } from "../data/site";
import { WhatsAppIcon } from "./icons";

const MESSAGES = [
    "Minimum order: 2 pieces",
    `Open daily · ${SITE.hours}`,
    SITE.tobaccoFree,
    "We are also available on Swiggy & Zomato",
];

const Ticker = ({ hidden = false }) => (
    <span className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
        {MESSAGES.map((message) => (
            <span key={message} className="flex items-center">
                <span className="px-6 text-[11px] font-semibold uppercase tracking-[0.18em] text-saga-cream/90 sm:text-xs">
                    {message}
                </span>
                <span className="h-1 w-1 rounded-full bg-saga-cream/50" aria-hidden="true" />
            </span>
        ))}
    </span>
);

const AnnouncementBar = () => (
    <div
        data-testid="announcement-bar"
        className="fixed inset-x-0 top-0 z-50 flex h-9 items-center bg-saga-red"
    >
        <div className="relative flex-1 overflow-hidden">
            <div className="marquee-track flex w-max hover:[animation-play-state:paused]">
                <Ticker />
                <Ticker hidden />
            </div>
        </div>
        <a
            href={WA.general}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="announcement-whatsapp-link"
            aria-label="Chat with Paan Saga on WhatsApp"
            className="mr-2 hidden shrink-0 items-center gap-1.5 rounded-full border border-saga-cream/40 px-3 py-0.5 text-[10px] font-bold uppercase tracking-[0.15em] text-saga-cream transition-colors hover:bg-saga-cream hover:text-saga-red sm:inline-flex"
        >
            <WhatsAppIcon className="h-3 w-3" />
            Chat
        </a>
    </div>
);

export default AnnouncementBar;
